"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCompanyConfig = exports.DEFAULT_COMPANY = exports.COMPANY_CONFIG = void 0;
const COMPANY_CONFIG = exports.COMPANY_CONFIG = {
  POLLUX: {
    name: 'Pollux Automation',
    url: 'https://www.pollux.com.br',
    copyrightYear: '1998'
  },
  ACCENTURE: {
    name: 'Accenture',
    url: 'https://www.accenture.com',
    copyrightYear: '1998'
  }
};
const DEFAULT_COMPANY = exports.DEFAULT_COMPANY = 'POLLUX';
const getCompanyConfig = () => {
  return COMPANY_CONFIG[DEFAULT_COMPANY];
};
exports.getCompanyConfig = getCompanyConfig;